import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/tilaa.webp';
import screenshot_target from '../../../images/letterfunnel/berrylangerak.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Berry Langerak"
      firstname="Berry"
      companyname="Tilaa"
      competition="Leaseweb en DigitalOcean"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/berrylangerak.js